import { AvatarService } from './avatar.service';
import {
   Component,
   ElementRef,
   HostListener,
   OnInit,
   OnDestroy,
   Renderer2,
   ViewChild,
   DoCheck,
   ViewChildren,
   QueryList
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterEvent, NavigationEnd, NavigationStart } from '@angular/router';
import { IdexService } from './idex.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { getActiveLang } from './shared/lang';
import { DataService } from './data.service';
import { ChangeAvatarComponent } from './account/change-avatar/change-avatar.component';
import { ChangePasswordComponent } from './account/change-password/change-password.component';
import { SetpasswordDialogComponent } from './e-signature/setpassword-dialog/setpassword-dialog.component';
import { FoldersComponent } from './dms/folders/folders.component';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FileUploader } from './dms/file-uploader';
import { app } from '../environments/version';
import { PersonalCertificateComponent } from './account/personal-certificate/personal-certificate.component';
import { AppLoaderComponent } from './shared/app-loader/app-loader.component';
import { SharedLoaderService } from './sharedLoader.service';
import { getCookie, setCookie } from './shared/cookie';

declare const moment: any;

@Component({
   selector: 'app-idex',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, DoCheck {
   @ViewChild('header') header: ElementRef;
   @ViewChild('leftNav') leftNav: ElementRef;
   @ViewChild('folders') folder: FoldersComponent;
   @ViewChild('contentLoader', { static: true }) contentLoader: ElementRef<HTMLElement>;
   @ViewChild('container', { static: true }) container: ElementRef;
   @ViewChild('footer', { static: true }) footer: ElementRef;
   @ViewChild('ul') ul: ElementRef;
   // Using @ViewChildren instead of @ViewChild to re-detect component after *ngIf destroyed and re-created it
   @ViewChildren('loader') loaderQuery: QueryList<AppLoaderComponent>;
   private loader: AppLoaderComponent;

   companyPath: string;
   public isConsented = false;
   module: string;
   title: string;
   errorMessage: string;
   successMessage: string;
   user: any;
   usedPercentage = 0;
   quotaInfo: any;
   lang: string;
   alternateLanguage: string;
   avatarUrl: string;
   avatar2Url: string;
   avatarLoaded: boolean;
   avatar2Loaded: boolean;
   uploading: boolean;
   taskid: any;
   device: string;
   menuOpened: boolean;
   user_role: any;

   opened = true;
   showBackdrop = false;
   hidden = true;
   currentUrl: string;
   clearStyle: boolean;
   versionInfo = '';
   ndid = false;
   ekyc = false;
   verifiedNdid: string;
   verifiedEkyc: string;
   securityPath: string;
   browserInfo: string;
   private routeSubscription: Subscription;
   private firstNavigationSubscription: Subscription;
   private isFirstNavigation = true;
   private _mode: string;
   private component: any;
   hideAvatar = false;

   // Browser compatibility banner
   showBrowserWarning = true;
   recommendedChromeVersion = '90'; // minimum recommended Chrome version
   browserWarningDismissed = false;

   constructor(
      private router: Router,
      public service: IdexService,
      private renderer: Renderer2,
      private dialog: MatDialog,
      private translate: TranslateService,
      iconRegistry: MatIconRegistry,
      sanitizer: DomSanitizer,
      private fileUploader: FileUploader,
      private dataService: DataService,
      private avatarService: AvatarService,
      private sharedLoaderService: SharedLoaderService
   ) {
      this.isConsented = this.hasCookie('g_user');

      iconRegistry.addSvgIcon('invisible', sanitizer.bypassSecurityTrustResourceUrl('../assets/images/invisible.svg'));
      iconRegistry.addSvgIcon('visible', sanitizer.bypassSecurityTrustResourceUrl('../assets/images/visible.svg'));
      iconRegistry.addSvgIcon('span', sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/edit_black_24dp.svg'));

      this.routeSubscription = this.router.events
         .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
         .subscribe((event) => {
            this.routeChanged(event);
         });

      // NavigationStart, so this runs before the task list is created and reads the selection
      this.firstNavigationSubscription = this.router.events
         .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
         .subscribe((event) => {
            if (this.isFirstNavigation) {
               this.isFirstNavigation = false;
               this.dataService.forgetTaskFilterOnFreshTaskList(event.url);
            }
         });
   }

   ngOnInit() {
      this.hideAvatar = false;
      this.user = this.service.user;
      // The active language is already loaded by the APP_INITIALIZER in AppModule; use() below
      // only re-applies it from cache, so no i18n request is repeated.
      this.lang = getActiveLang();
      this.translate.setDefaultLang('en');
      if (this.lang === 'cn') {
         this.translate.use('cn')
         moment.locale('zh-cn');
      } else {
         this.translate.use(this.lang)
         moment.locale(this.lang);
      }
      this.initLanguage();
      this.browserInfo = this.service.getBrowserInfo();
      this.checkBrowserCompatibility();

      const version = app.version.substr(0, app.version.lastIndexOf('.') + 5);
      const buildDate = moment(app.buildDate);
      const date =
         this.lang === 'th'
            ? `${buildDate.format('D MMMM')} ${buildDate.year() + 543}`
            : buildDate.format('MMMM D, YYYY');
      this.translate.get('release-note', { version, date }).subscribe(
         (s) => (this.versionInfo = s),
         (e) => (this.versionInfo = e)
      );

      localStorage.removeItem('first_sign');
      if (window.location.pathname !== undefined) {
         const url = window.location.pathname.replace('/idex', '');
         // check user (share public folder)
         if (url.startsWith('/firstsign/')) {
            this.taskid = url.replace('/firstsign/', '').split('/')[0];
            this.device = url.replace('/firstsign/', '').split('/')[1];
            const urlParams = new URLSearchParams(window.location.search);
            const activateKey = urlParams.get('key');
            this.service
               .post('/activatesign?key=' + activateKey + '&taskId=' + this.taskid + '&browserInfo=' + this.browserInfo)
               .subscribe(
                  (data: any) => {
                     if (data !== true) {
                        this.service.setUser(data);
                        this.user = this.service.user;
                     }

                     if (this.user) {
                        this.updateUserInfo(this.user);
                        this.router.navigate(['/signdoc', this.taskid, this.device], { replaceUrl: true });
                        localStorage.setItem('first_sign', 'true');
                     } else {
                        if (this.taskid !== undefined) {
                           this.router.navigate(['/login', this.taskid, this.device], { replaceUrl: true });
                        } else {
                           this.router.navigate(['/login', this.device], { replaceUrl: true });
                        }
                     }
                  },
                  (error) => {
                     this.errorMessage = error;
                  }
               );
         } else if (url.startsWith('/callback') || url.startsWith('/callback-dropbox')) {
            this.hideAvatar = true;
         } else {
            if (this.user) {
               this.updateUserInfo(this.user);
            }
         }
      } else {
         if (this.user) {
            this.updateUserInfo(this.user);
         }
      }

      this._mode = 'side';
      this.openNavBar();
      this.setMargin(true);
      if (window.innerWidth < 1000) {
         this.setTooltip(true);
      }

      if (this.loaderQuery) {
         this.loader = this.loaderQuery.first;
      }

      this.avatarService.avatarUrl$.subscribe((url) => {
         this.avatarUrl = url;
      });

      this.avatarService.avatar2Url$.subscribe((url) => {
         this.avatar2Url = url;
      });

      //=================================================================
      // Allow child components to call loader to cover the content-area
      //=================================================================
      this.sharedLoaderService.showLoader$.subscribe(() => {
         this.loader = this.loaderQuery.first;
         if (this.loader) {
            this.loader.show();
         }
      });

      this.sharedLoaderService.hideLoader$.subscribe(() => {
         this.loader = this.loaderQuery.first;
         if (this.loader) {
            this.loader.hide();
         }
      });
   }

   ngDoCheck(): void {
      const footerHeight = (this.footer?.nativeElement as HTMLElement)?.offsetHeight;
      if (this.contentLoader && footerHeight) {
         this.renderer.setStyle(this.contentLoader.nativeElement, 'bottom', `${footerHeight}px`);
      }
   }

   ngOnDestroy(): void {
      this.routeSubscription.unsubscribe();
      this.firstNavigationSubscription.unsubscribe();
   }

   @HostListener('window:dragover', ['$event'])
   @HostListener('window:drop', ['$event'])
   onWindowDragOver(e: DragEvent): boolean {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'none';
      return false;
   }

   @HostListener('window:scroll')
   onWindowScroll() {
      if (this.header !== undefined || this.leftNav !== undefined) {
         if (this.header.nativeElement) {
            this.header.nativeElement.style.left = -window.scrollX + 'px';
         }
         if (this.leftNav.nativeElement) {
            this.leftNav.nativeElement.style.left = -window.scrollX + 'px';
         }
      }
   }

   @HostListener('window:beforeunload')
   onUnload() {
      if (this.fileUploader.busy) {
         return false;
      } else {
         return true;
      }
   }

   setUser(user: any) {
      this.user = user;
      this.updateUserInfo(user);
      if (this.folder) {
         if (this.folder.animationState === 'expand') {
            this.folder.animationState = 'collapse';
            this.folder.folders = undefined;
         }
      }
   }

   public updateUserInfo(user: any): void {
      this.usedPercentage = Math.floor((this.user.used * 100) / this.user.quota);
      this.avatarService.updateAvatarUrl(user.avatar ? this.service.url + user.avatar : 'assets/images/profile.png');
      this.avatarService.updateAvatar2Url(user.avatar2 ? this.service.url + user.avatar2 : 'assets/images/profile.png');

      this.user_role = '';
      if (user && user.business) {
         for (const b of user.business) {
            if (b.role === 'Admin') {
               this.user_role = b.role;
               break;
            }
         }
      }
   }

   initLanguage() {
      this.translate.get('lang-alternate').subscribe((s) => {
         this.alternateLanguage = s;
      });
   }

   changeLanguage(lang) {
      localStorage.setItem('lang', lang);
      this.translate.get('lang-changing').subscribe((s) => {
         this.alternateLanguage = s;
      });
      setTimeout(() => {
         location.reload();
      }, 100);
   }

   cookieAccept(name: string, value: string, expireDays: number) {
      const d: Date = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      // setCookie always writes path=/, so the consent covers every route. Without it the
      // browser scopes the cookie to the route the banner was accepted on and the banner
      // comes back everywhere else.
      setCookie(name, value, d);
      this.isConsented = this.hasCookie(name);
   }

   hasCookie(name: string): boolean {
      // Truthiness rather than a comparison against '': a cookie that is not set has no value
      // to compare, and reading that as "consented" is what kept the notice off the screen.
      return !!getCookie(name);
   }

   selectApp(s: string): void {
      window.localStorage.removeItem('path_company');
      if (this.module === s && s !== 'company') {
         return;
      }
      this.hidden = false;
      this.openNavBar();
      if (s === 'dashboard') {
         this.router.navigate(['/']);
         window.scrollTo(0, 0);
         this.hidden = true;
      } else if (s === 'dms') {
         this.router.navigate(['/files']);
      } else if (s === 'sign') {
         sessionStorage.setItem('taskPath', '/tasks/all');
         this.router.navigate(['/tasks/all']);
      } else if (s === 'saraban') {
         this.router.navigate(['/saraban']);
      } else if (s === 'company') {
         this.router.navigate(['/company-list']);
         this.hidden = true;
      } else if (s === 'passport') {
         this.router.navigate(['/passport-list']);
         this.hidden = true;
      } else if (s === 'profile') {
         this.router.navigate(['/general']);
         this.hidden = true;
      }
   }

   openSetPassword() {
      this.dialog.open(SetpasswordDialogComponent, {
         disableClose: true,
         data: this,
         width: '350px'
      });
   }

   openChangePassword() {
      this.dialog.open(ChangePasswordComponent, {
         disableClose: true,
         data: this
      });
   }

   openChangeAvatar(e: Event) {
      e.stopPropagation();
      this.dialog.open(ChangeAvatarComponent, {
         disableClose: true,
         data: this
      });
   }

   openPersonalCert() {
      this.dialog.open(PersonalCertificateComponent, {
         disableClose: true,
         data: this
      });
   }

   updateAvatar(data: any): void {
      this.avatarLoaded = false;
      this.avatar2Loaded = false;
      setTimeout(() => {
         if (!this.user.avatar) {
            this.user = data;
            this.service.setUser(data);
         }
         const time = new Date().getTime();
         this.avatarService.updateAvatarUrl(this.service.url + this.user.avatar + '&' + time);
         this.avatarService.updateAvatar2Url(this.service.url + this.user.avatar2 + '&' + time);
      }, 200);
   }

   logout(): void {
      this.verifiedNdid = null;
      this.verifiedEkyc = null;
      this.user = undefined;
      this.service.logout();
      this.service.logoutGoogleApi();
      this.service.removeMicrosoftAuth();
      this.service.removeDropboxAuth();
      this.router.navigate(['/login']);
      this.clearMargin();
   }

   openNav() {
      document.getElementById('myNav').style.width = '100%';
   }

   closeNav() {
      document.getElementById('myNav').style.width = '0%';
   }

   onRouterOutletActivate(component: any): void {
      this.component = component;
   }

   openTutorial() {
      if (this.component && this.component.onStartTutorial) {
         try {
            this.component.onStartTutorial();
         } catch (e) {
            console.error(e);
         }
      }
   }

   openMenu() {
      this.service.get('/quota').subscribe((data) => {
         this.user.used = data.used;
      });
   }

   private routeChanged(event: RouterEvent): void {
      let url = event.url;
      this.currentUrl = url;
      this.dataService.forgetTaskFilterOutsideTaskArea(url);
      this.clearStyle = false;
      this.hidden = true;
      this.setMargin(this.opened);
      if (url === '/' || url === '/dashboard') {
         this.module = 'dashboard';
      } else if (
         url === '/files' ||
         url.indexOf('/files/') === 0 ||
         url.indexOf('/work/') === 0 ||
         url.indexOf('/search') === 0 ||
         url === '/trash' ||
         url === '/sharedbyme' ||
         url.indexOf('/sharedbyme/') === 0 ||
         url === '/sharedwithme' ||
         url.indexOf('/sharedwithme/') === 0 ||
         url === '/sharedlink' ||
         url === '/googleDrivePage' ||
         url.indexOf('/googleDrivePage') === 0 ||
         url.indexOf('/googleDrivePage/') === 0 ||
         url === '/onedrivepage' ||
         url.indexOf('/onedrivepage/') === 0 ||
         url === '/dropboxPage' ||
         url.indexOf('/dropboxPage') === 0 ||
         url.indexOf('/dropboxPage/') === 0
      ) {
         this.module = 'dms';
      } else if (
         url.indexOf('/tasks/') === 0 ||
         url === '/workflows' ||
         url === '/templates' ||
         url === '/contact' ||
         url === '/group' ||
         url === '/auto-approve'
      ) {
         this.module = 'sign';
         this.hidden = false;
      } else if (url === '/plan' || url === '/general') {
         this.module = 'profile';
         this.hidden = false;
      } else if (url.indexOf('/saraban') === 0) {
         this.module = 'saraban';
      } else if (url.indexOf('/terms') === 0) {
         this.module = 'terms';
      } else if (url.indexOf('/privacy') === 0) {
         this.module = 'privacy';
      } else if (url.indexOf('/pdpa') === 0) {
         this.module = 'pdpa';
      } else if (
         url.indexOf('/admin-tool/') === 0 ||
         url.indexOf('/eform/list') === 0 ||
         url.indexOf('/eflow/list') === 0 ||
         url.indexOf('/package-manager/') === 0
      ) {
         this.module = 'company';
         this.hidden = false;
      } else if (url.indexOf('/company-list') === 0) {
         this.module = 'admin';
      } else if (url.indexOf('/passport-list') === 0) {
         this.module = 'passport';
      } else if (url.indexOf('/account/') === 0) {
         this.module = 'profile';
      } else {
         if (url.indexOf('/login/') !== 0 && url !== '/login') {
            if (url.indexOf('/files?') === 0) {
               this.module = 'dms';
               url = '/files';
            } else if (url.indexOf('/trash?') === 0) {
               this.module = 'dms';
               url = '/trash';
            } else if (url.indexOf('/login?') === 0) {
               url = '/login';
            } else if (url.indexOf('/signup') === 0) {
               url = '/signup';
            } else {
               this.module = 'dashboard';
               url = '/';
            }
         }
      }

      if (
         url === '/workflows' ||
         url === '/templates' ||
         url === '/contact' ||
         url === '/group' ||
         url.indexOf('/waiting/') === 0 ||
         url === '/forms' ||
         url === '/form' ||
         url === '/auto-approve'
      ) {
         this.renderer.addClass(document.body, 'no-header');
      } else {
         this.renderer.removeClass(document.body, 'no-header');
      }
      if (url === '/' || url === '/dashboard' || url === '/company-list' || url === '/passport-list') {
         this.renderer.addClass(document.body, 'header-shadow');
         this.clearMargin();
      } else {
         this.renderer.removeClass(document.body, 'header-shadow');
      }
      if (
         url === '/' ||
         url === '/dashboard' ||
         url === '/login' ||
         url.indexOf('/login/') === 0 ||
         url.indexOf('/signup') === 0 ||
         url === '/activate' ||
         url.indexOf('/reset') === 0 ||
         url === '/privacy' ||
         url === '/pdpa' ||
         url === '/terms' ||
         url.indexOf('/waiting/') === 0 ||
         url === '/forms' ||
         url === '/form' ||
         url === '/company-list' ||
         url === '/passport-list'
      ) {
         this.renderer.addClass(document.body, 'full-width');
         this.clearMargin();
      } else {
         this.renderer.removeClass(document.body, 'full-width');
      }
      if (url === '/login' || url.indexOf('/login/') === 0 || url.indexOf('/signup') === 0) {
         this.renderer.addClass(document.body, 'login-page');
         this.clearMargin();
      } else {
         this.renderer.removeClass(document.body, 'login-page');
      }
      if (
         url === '/' ||
         url === '/dashboard' ||
         url === '/company-list' ||
         url === '/forms' ||
         url === '/form' ||
         url === '/passport-list'
      ) {
         this.renderer.addClass(document.body, 'gray');
      } else {
         this.renderer.removeClass(document.body, 'gray');
      }
      this.translate.get('main.' + this.module).subscribe((s) => (this.title = s));
   }

   clearMargin() {
      this.clearStyle = true;
      if (this.container) {
         this.renderer.setStyle(this.container.nativeElement, 'margin-left', '0px');
      }
      if (this.contentLoader) {
         this.renderer.setStyle(this.contentLoader.nativeElement, 'left', '0');
      }
      if (this.footer) {
         this.renderer.setStyle(this.footer.nativeElement, 'left', '0');
      }
   }

   @HostListener('window:resize')
   onWindowResize(): void {
      if (window.innerWidth < 1000) {
         if (this._mode !== 'over') {
            this._mode = 'over';
            this.closeNavBar();
         }
      } else if (this._mode !== 'side') {
         this._mode = 'side';
         this.openNavBar();
      }
   }

   toggleNavBar(isOpen: boolean = !this.opened): void {
      if (!this.clearStyle) {
         this.opened = isOpen;
         this.showBackdrop = isOpen;
         this.setMargin(isOpen);
         this.setTooltip(!isOpen);
      }
   }

   onClickPrivacy() {
      this.lang = localStorage.getItem('lang') || 'en';
      if (this.lang === 'th') {
         window.open('https://www.zdox.net/th/privacy', '_blank');
      } else {
         window.open('https://www.zdox.net/privacy', '_blank');
      }
   }

   private openNavBar(): void {
      this.toggleNavBar(true);
   }

   private closeNavBar(): void {
      this.toggleNavBar(false);
   }

   private setMargin(add: boolean): void {
      if (!this.container) {
         return;
      }
      const dom: HTMLElement = this.container.nativeElement;
      const elements = dom.querySelectorAll('.subheader');
      const subheader = elements.length > 1 ? elements[1] : elements[0];

      if (add) {
         this.renderer.setStyle(this.container.nativeElement, 'margin-left', '0px');
         if (this.footer) {
            this.renderer.setStyle(this.footer.nativeElement, 'left', '240px');
         }
         if (this.contentLoader) {
            this.renderer.setStyle(this.contentLoader.nativeElement, 'left', '240px');
         }
         if (subheader) {
            this.renderer.setStyle(subheader, 'left', '240px');
         }
      } else {
         this.renderer.setStyle(this.container.nativeElement, 'margin-left', '-190px');
         if (this.footer) {
            this.renderer.setStyle(this.footer.nativeElement, 'left', '50px');
         }
         if (this.contentLoader) {
            this.renderer.setStyle(this.contentLoader.nativeElement, 'left', '50px');
         }
         if (subheader) {
            this.renderer.setStyle(subheader, 'left', '50px');
         }
      }
   }

   private setTooltip(show: boolean): void {
      if (this.ul) {
         for (const li of this.ul.nativeElement.children) {
            li.getElementsByTagName('a')[0].title = show ? li.getElementsByTagName('span')[0].innerText : '';
         }
      }
   }

   checkBrowserCompatibility(): void {
      // ตรวจสอบว่าผู้ใช้เคยปิด banner ไปแล้วหรือไม่
      const dismissed = localStorage.getItem('browserWarningDismissed');
      if (dismissed === 'true') {
         this.browserWarningDismissed = true;
         this.showBrowserWarning = false;
      } else {
         this.showBrowserWarning = true;
      }
   }

   dismissBrowserWarning(): void {
      this.showBrowserWarning = false;
      this.browserWarningDismissed = true;
      localStorage.setItem('browserWarningDismissed', 'true');
   }
}
